import { NgModule, InjectionToken } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { SubHeaderComponent } from './header/sub-header/sub-header.component';
import { GuideComponent } from './guide/guide.component';
import { CallbackComponent } from './callback/callback.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const routes: Routes = [
  { path: '', redirectTo: '/loan-images', pathMatch: 'full' },
  { path: 'guide', component: GuideComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent},
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'externalRedirect',
    resolve: {
      url: externalUrlProvider
    },
    component: SubHeaderComponent,
  },
  { path: '404', component: PageNotFoundComponent},
  { path: '*', redirectTo: '/loan-images', pathMatch: 'full'}
];

@NgModule({
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const externalUrl = route.paramMap.get('externalUrl');
        window.open(externalUrl, '_self');
      }
    }
  ],
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
